<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import {
	queryVoucherHeaderData,
	getNewErpNo,
	postVoucher,
	unPostVoucher,
	deleteVoucher,
	queryVoucherInfo,
	saveOrUpdateVoucher,
	validateCreateCondition,
	getCurrencyConfigData,
	getYear,
	getFinancialPeriod,
	getCACodeDesc
} from '../../../../api/home.js';
import config from '../../../../../configHttp';
export default {
	name: 'VoucherQuery',
	data() {
		return {
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: getdata().headData,
			headData: JSON.parse(localStorage.getItem('VoucherQueryheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('VoucherQueryoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			tableHeight: 'calc(100vh - 325px )',
			Count: 0,
			/* 表格 */
			headerJson: {},

			detailJson: [],
			sort: '',
			order: '',
			advanced: false,
			form: getdata().form,
			formdata: getdata().formdata,
			formtime: getdata().formtime,
		};
	},
	mounted() {},
	activated() {
		this.searrchForData();
	},
	created() {
		this.searrchForData();
	},
	methods: {
		//导出
		derive() {
			let params = {};
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				params.criteriaJson = JSON.stringify(this.searchdata);
			} else {
				params.criteriaJson = JSON.stringify({
					ids: this.$refs.tablebox
						.getSelectionval()
						.map(v => v.id)
						.join(',')
				});
			}
			let req = {
				downUrl: config.baseURL + '/fvm/voucher/exportVoucher',
				typeObj: {
					toForm: false,
					fileType: 'xls',
					fileName: '凭证查询数据' + this.$timestampToStr(new Date(), 'yyyyMMdd')
				},
				params: params
			};
			this.$downloadcommon(req);
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('VoucherQueryoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('VoucherQueryheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		duplication(id) {
			this.$router.push({
				path: '/VoucherDetail',
				query: {
					id: '-1',
					duplicationid: id
				}
			});
		},
		InitializeJiem(id) {
			let params = {};
			params.id = id;
			queryVoucherInfo(params).then(res => {
				if (res.data.code == '200') {
					this.headerJson = res.data.data.header;
					this.headerJson.pingzrq = this.formatDate(this.headerJson.pingzrq);
					this.detailJson = res.data.data.details;
					//获取当前生成的ERP凭证号
					getNewErpNo().then(res => {
						this.headerJson.pingzh = res.data.data;
						let paramss = {};
						paramss.headerJson = JSON.stringify(this.headerJson);
						paramss.detailJson = JSON.stringify(this.detailJson);
						saveOrUpdateVoucher(paramss).then(res => {
							if (res.data.code == '200') {
								this.$message.success('复制成功');
								this.searrchForData();
							} else {
								this.$message.error(res.data.message);
							}
						});
					});
				}
			});
		},
		formatDate(value) {
			// 时间戳转换日期格式方法
			if (value == null) {
				return value;
			} else {
				const date = new Date(value);
				const y = date.getFullYear(); // 年
				let MM = date.getMonth() + 1; // 月
				MM = MM < 10 ? '0' + MM : MM;
				let d = date.getDate(); // 日
				d = d < 10 ? '0' + d : d;
				return y + '-' + MM + '-' + d;
			}
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//删除
		expurgate(id) {
			if (id == '-1') {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择要删除的数据！');
					return;
				}
				this.$showConfirm({
					message: '确认操作?'
				}).then(res => {
					if (res == 'confirm') {
						let params = {};
						params.ids = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
						deleteVoucher(params).then(res => {
							if (res.data.code == '200') {
								this.$message.success('删除成功');
								this.searrchForData();
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			} else {
				this.$showConfirm({
					message: '确认操作?'
				}).then(res => {
					if (res == 'confirm') {
						let params = {};
						params.ids = id;
						deleteVoucher(params).then(res => {
							if (res.data.code == '200') {
								this.$message.success('删除成功');
								this.searrchForData();
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			}
		},
		//过账
		postingofAccount(id) {
			if (id == '-1') {
				if (this.$refs.tablebox.getSelectionval().length != 1) {
					this.$message.error('请选择一条数据进行过账！');
					return;
				}
				if (this.$refs.tablebox.getSelectionval()[0].guozzt == '1') {
					this.$message.error('数据已过账不能再次操作！');
					return;
				}
				let params = {};
				params.id = this.$refs.tablebox.getSelectionval()[0].id;
				postVoucher(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('过账成功');
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			} else {
				let params = {};
				params.id = id;
				postVoucher(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('过账成功');
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
		},
		ReversePosting(id) {
			if (id == '-1') {
				if (this.$refs.tablebox.getSelectionval().length != 1) {
					this.$message.error('请选择一条数据进行反过账！');
					return;
				}
				if (this.$refs.tablebox.getSelectionval()[0].guozzt != '1') {
					this.$message.error('只有已过账的数据能进行反过账！');
					return;
				}
				let params = {};
				params.id = this.$refs.tablebox.getSelectionval()[0].id;
				unPostVoucher(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('反过账成功');
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			} else {
				let params = {};
				params.id = id;
				unPostVoucher(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('反过账成功');
						this.searrchForData();
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
		},
		empty() {
			this.formdata = getdata().formdata;
		},
		advancedtk() {
			this.formdata = getdata().formdata;
			this.form = getdata().form;
			this.GainBz();
			this.GainNd();
			this.GainCwqj();
			this.GainKmdm();
			this.advanced = true;
		},
		//获取币种 TODO 默认选中本币
		GainBz() {
			let params = {};
			getCurrencyConfigData().then(res => {
				if (res.data.code == '200') {
					this.form[11].selectval = res.data.data.map(v => {
						// if (v.standardCurrency == '1') {
						// 	this.formdatajbxx.currency = v.currency;
						// }
						return {
							label: v.currency,
							value: v.currency
						};
					});
				}
			});
		},
		//获取年度
		GainNd() {
			let params = {};
			getYear().then(res => {
				// this.formdatajbxx.cains = new Date().getFullYear();
				for (var i = res.data.data.max; i >= res.data.data.min; i--) {
					this.form[0].selectval.push({
						label: i,
						value: i
					});
				}
			});
		},
		//获取财务期间
		GainCwqj(year) {
			let params = {};
			params.year = year;
			getFinancialPeriod(params).then(res => {
				if (res.data.code == '200') {
					this.form[1].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
				} else {
					this.form[1].selectval = [];
				}
			});
		},
		//获取中方科目
		GainKmdm() {
			let params = {};
			params.likeSearch = '';
			params.isLastLevel = false;
			getCACodeDesc(params).then(res => {
				if (res.data.code == '200') {
					this.form[7].selectval = res.data.data.map(v => {
						return {
							label: v.key+"-"+v.value,
							value: v.key
						};
					});
				}
			});
		},
		advancedquery() {
			let params = {};
			
			params.criteriaJson = JSON.stringify(this.formdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			queryVoucherHeaderData(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data.map(v => {
						v.pingzrq = this.formatDate(v.pingzrq);
						v.guozrq = this.formatDate(v.guozrq);
						v.gengxsj = this.formatDate(v.gengxsj);
						return v;
					});
					this.pagination.total = res.data.count;
					this.advanced = false;
				}
			});
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			queryVoucherHeaderData(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data.map(v => {
						v.pingzrq = this.formatDate(v.pingzrq);
						v.guozrq = this.formatDate(v.guozrq);
						v.gengxsj = this.formatDate(v.gengxsj);
						return v;
					});
					this.pagination.total = res.data.count;
				}
			});
			getYear().then(res => {
				let periodParams = {};
				getFinancialPeriod(periodParams).then(res2 => {
					let caCodeParams = {};
					caCodeParams.likeSearch = '';
					caCodeParams.isLastLevel = false;
					getCACodeDesc(caCodeParams).then(res3 => {
						this.searchlist = getdata().searchlist;
						for (var i = res.data.data.max; i >= res.data.data.min; i--) {
							this.searchlist[2].selectval.push({
								label: i,
								value: i
							});
						}
						this.searchlist[3].selectval = res2.data.data.map(v => {
							return {
								label: v.name,
								value: v.value
							};
						});
						this.searchlist[9].selectval = res3.data.data.map(v => {
							return {
								label: v.key+"-"+v.value,
								value: v.key
							};
						});
					});
				});
			});
		},
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},
		fordetail(id) {
			this.$router.push({
				path: '/PreviewVoucher',
				query: {
					id: id
				}
			});
			// this.$router.push('/PreviewVoucher');
		},
		forupdate(id,guozzt) {
			if(guozzt == "1"){
				this.$message.error("已过帐凭证不允许编辑！");
				return;
			}
			validateCreateCondition().then(res => {
				if (res.data.code == '200') {
					this.$router.push({
						path: '/VoucherDetail',
						query: {
							id: id,
							timestamp: id == '-1' ? new Date().getTime() : ''
						}
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
